import { minBy } from 'es-toolkit';

import { Component, Member } from '@paragon/contract-library';
import { Line2D, Point2D } from '@paragon/geometry-library';
import { calculateMemberMidline, calculateMemberPolygon } from '@paragon/three-shared';
import { notNullish } from '@paragon/utilities';

import { AngleDimensionProps } from './AngleDimension';

export const getAngleDimensionsForMember = (member: Member, component: Component): AngleDimensionProps[] => {
  const memberPolygon = calculateMemberPolygon(member, component);
  const memberMidline = calculateMemberMidline(member, component);
  if (!memberPolygon || !memberMidline) return [];

  const memberMidlineAsLine = Line2D.fromPoints(
    Point2D.fromObject(memberMidline.start),
    Point2D.fromObject(memberMidline.end),
  );
  const edgesNotParallelToMidline = memberPolygon.edges.filter(
    (edge) => !edge.direction.isParallelTo(memberMidlineAsLine.direction),
  );

  return edgesNotParallelToMidline
    .map((edge) => {
      const basePoint = minBy(edge.endPoints, (endPoint) => endPoint.distanceToLine(memberMidlineAsLine));
      if (!basePoint) return null;
      const endLineEndPoint = edge.endPoints.filter((point) => point !== basePoint)[0];

      const perpendicularLineBasePoint = basePoint.projectOntoLine(memberMidlineAsLine);
      const perpendicularLineToMidline = new Line2D(
        perpendicularLineBasePoint,
        memberMidlineAsLine.direction.rotateQuarterTurn(),
      );
      const baseLineEndPoint = endLineEndPoint.projectOntoLine(perpendicularLineToMidline);

      return {
        basePoint: basePoint.toObject(),
        baseLineEndPoint: baseLineEndPoint.toObject(),
        endLineEndPoint: endLineEndPoint.toObject(),
      };
    })
    .filter(notNullish);
};
